const payout_types = [
    { payoutMode: 1, description: "1st Cutoff" },
    { payoutMode: 2, description: "2nd Cutoff" },
    { payoutMode: 3, description: "Split Per Cutoffs" },
    { payoutMode: 4, description: "Once A Month" }
];
export default payout_types;